import { createContext } from "react";
export const SealedFieldsContext = createContext<string[]>([]);
